illb2bJq(function () {

  //variant変更時処理（商品詳細のみの処理）
  illb2bJq('.product__info-wrapper').on("change", function (event) {
    //情報取得
    let targetProduct = illb2bJq("#illi-restock-request");
    let targetInfoObj = targetProduct.data("illiRestocks");
    let variantId = getParam("variant");
    //variantが変更されている場合のみ処理
    if (variantId != null && variantId != targetInfoObj.variantId) {
      //changeイベントにタイムラグが存在するのでローディング（ロック）しておく
      screenLock();

      //変更後のvariantの情報に更新する
      let changedVariantTitle = illb2bJq('#illi-notify-restocks-variantTitle-' + String(variantId)).val();
      let changedInfoObj = {
        productId: targetInfoObj.productId,
        productTitle: targetInfoObj.productTitle,
        variantId: variantId,
        variantTitle: changedVariantTitle,
        hasOnlyDefaultVariant: targetInfoObj.hasOnlyDefaultVariant
      }
      targetProduct.data("illiRestocks",changedInfoObj);
      //console.log(targetProduct.data("illiRestocks")); デバッグ用

      let targetVariant = illb2bJq('#illi-notify-restocks-targetVariant').val();
      if (targetVariant) {
        //variantが処理対象か確認する
        let variants = targetVariant.split(',');
        if (variants.includes(String(variantId))) {
          //対象の場合は申し込みボタンを表示
          illb2bJq('.illi-notify-restocks-accept-button').removeClass('is-hidden');
          //variant変更イベント完了時にロック解除
          if(event.target.type == 'hidden'){
            screenUnlock();
          }
        }else {
          //対象外の場合は申し込みボタンを非表示
          illb2bJq('.illi-notify-restocks-accept-button').addClass('is-hidden');
          screenUnlock();
        }
      }else {
        //対象外の場合は申し込みボタンを非表示
        illb2bJq('.illi-notify-restocks-accept-button').addClass('is-hidden');
        screenUnlock();
      }
    }
  });

  //入荷お知らせを受け取るボタン押下時
  illb2bJq(document).on('click','.illi-notify-restocks-accept-button', function () {
    //初期表示時にエラーを非表示に戻す
    illb2bJq('.illi-notify-restocks-accept-errorMessage').addClass('is-hidden');
    var dialog = document.getElementById("illi-notify-restocks-accept-dialog");

    //商品情報をセット
    let targetObj = illb2bJq(this).data("illiRestocks");
    illb2bJq('#illi-restock_product_id').val(targetObj.productId);
    illb2bJq('#illi-restock_variant_id').val(targetObj.variantId);
    let displayTitle
    if(targetObj.hasOnlyDefaultVariant){
      displayTitle = targetObj.productTitle
    }else{
      displayTitle = `${targetObj.productTitle} - ${targetObj.variantTitle}`
    }
    illb2bJq('.illi-notify-restocks-DisplayTitle').text(displayTitle);
    dialog.showModal();
  });
  // 申し込みダイアログ×ボタン押下時
  illb2bJq('.illi-notify-restocks-accept-close-text span').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-accept-dialog");
    dialog.close();
  });

  //申し込むボタン押下時
  illb2bJq('.illi-notify-restocks-post-button').on('click', function () {
    var email = illb2bJq('.illi-notify-restocks-accept-email input').val();
    if (email) {
      //申し込み処理
      var productId = illb2bJq('#illi-restock_product_id').val();
      var variantId = illb2bJq('#illi-restock_variant_id').val();
      
      //ローディングするボタンを取得
      let targetElements = document.getElementsByClassName("illi-notify-restocks-post-button");
      screenLock(targetElements[0]);
      postAcceptrestocks(email, variantId, productId);
    } else {
      //emailの入力がない場合はエラー
      illb2bJq('.illi-notify-restocks-accept-errorMessage span').text("メールアドレスが入力されていません。");
      illb2bJq('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
    }
  });

  // 完了ダイアログ×ボタン押下時
  illb2bJq('.illi-notify-restocks-message-close-text span').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-message-dialog");
    dialog.close();
  });

  //完了ダイアログ閉じるボタン押下時
  illb2bJq('.illi-notify-restocks-message-close-button').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-message-dialog");
    dialog.close();
  });
});

//URLから指定したパラメータを取得
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

//入荷お知らせ機能にpostする
function postAcceptrestocks(email, variantId, productId) {
  illb2bJq.ajax({
    url: '/apps/notify-restocks/accept',
    type: 'POST',
    dataType: 'json',
    data: {
      mail: email,
      variantId: variantId,
      productId: productId
    },
    timeout: 30000,
  }).then(
    function (res) {
      if (res.status == 'success') {
        //メールアドレスを表示
        illb2bJq('.illi-notify-restocks-message-email').text(email);
        // 成功した場合は、完了ダイアログを表示
        var dialog = document.getElementById("illi-notify-restocks-message-dialog");
        dialog.showModal();
        dialog = document.getElementById("illi-notify-restocks-accept-dialog");
        dialog.close();
      } else {
        // 失敗した場合は、エラーを表示
        illb2bJq('.illi-notify-restocks-accept-errorMessage span').text(res.result);
        illb2bJq('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
      }
      screenUnlock();
    },
    function () {
      // 失敗した場合は、エラーを表示
      illb2bJq('.illi-notify-restocks-accept-errorMessage span').text("no connection.");
      illb2bJq('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
      screenUnlock();
      return null;
    }
  );
}